module.exports = __webpack_public_path__ + "static/media/laptop_1.a91483f1.png";